import { createPricingRoute } from '@wetransfer/transfer/helper/routeFactory';
import { isLoggedInFreeUser } from '@wetransfer/transfer/helper/user';
import { State } from '@wetransfer/transfer/store/types';

export const getHrefTransferLimit = (user: State['user']): string => {
  if (isLoggedInFreeUser(user)) {
    return createPricingRoute('TT_limit_2');
  }

  return createPricingRoute('TT_limit_200');
};
